import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonComponent } from '@retail-portal-santander-frontend/remote-shared-ui-button';

@Component({
  standalone: true,
  selector: 'allianz-edit-button',
  templateUrl: './edit-button.component.html',
  imports: [ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditButtonComponent {
  disabled = input<boolean>(false);
  action = input<() => void>();
  nxButtonType = input<string>();
}
